import React from "react";
import PropTypes from "prop-types";

const InputListHandler = ({ values, addItem, children }) => {
  React.useEffect(() => {
    if (values && values.length === 0) {
      addItem();
    }
  }, [values]);

  return children;
};

InputListHandler.propTypes = {
  addItem: PropTypes.func.isRequired,
  values: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default InputListHandler;
